import 'floating-vue/dist/style.css'
import './assets/styles/main.css'

import { createApp } from 'vue'
import { createHead } from '@unhead/vue'
import { createPinia } from 'pinia'
import HoneybadgerVue from '@honeybadger-io/vue'
import FloatingVue from 'floating-vue'
import { useNotificationStore } from '@/stores/notification'

import App from './App.vue'
import router from './router'
import 'flowbite'
import { useHotjarStore } from '@/stores/hotjar'
import { useGoogleTagManagerStore } from '@/stores/google-tag-manager'

const app = createApp(App)
const head = createHead()
const config = {
  apiKey: import.meta.env.VITE_HONEYBADGER_API_KEY,
  environment: import.meta.env.VITE_HONEYBADGER_ENVIRONMENT,
  revision: import.meta.env.VITE_HONEYBADGER_REVISION
}

app.use(createPinia())
app.use(router)
app.use(head)
app.use(HoneybadgerVue, config)
app.use(FloatingVue)

app.$honeybadger.beforeNotify((notice) => {
  const message = notice.context?.errorMessage || notice.message

  if (
    message &&
    (message.includes('is not a valid JavaScript MIME type') ||
      message.includes('Unable to preload CSS') ||
      message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Failed to resolve import'))
  ) {
    const notificationStore = useNotificationStore()
    notificationStore.notifyReload = true
    return false
  }

  if (message && message.includes('Failed to load Stripe.js')) {
    window.location.reload()
    return false
  }

  if (message && message.includes('The operation either timed out or was not allowed')) {
    return false
  }

  return true
})

window.gmo = window.gmo || {}

useGoogleTagManagerStore().init()
useHotjarStore().init()

app.mount('#app')
